import { DialogTitle } from "@radix-ui/react-dialog";
import { DialogContent, DialogFooter } from "../../../components/dialog";
import { Button } from "../../../components";

interface AlertTimeFilterPopupProps {
    dialogContentProps?: React.ComponentProps<typeof DialogContent>;
    onOk?: () => void;
    onClearFilter?: () => void;
}

const AlertTimeFilterPopup = ({ dialogContentProps, onOk, onClearFilter }: AlertTimeFilterPopupProps) => {
  return (
    <DialogContent {...dialogContentProps} className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white">
        <DialogTitle></DialogTitle>
        <div>Please select a range to filter!</div>
        <DialogFooter>
            <Button onClick={onOk}>Ok</Button>
            <Button onClick={onClearFilter}>Clear Filter</Button>
        </DialogFooter>
    </DialogContent>
  );
}

export default AlertTimeFilterPopup;